
  import {Component, Vue} from 'vue-property-decorator';
  import Weather from '../components/weather.vue';
  import PointContent from '../components/pointContent.vue';
  import {Guid} from 'guid-typescript';
  import L from 'leaflet';
  import 'leaflet-polylinedecorator';
  import 'leaflet-rotatedmarker';
  import 'leaflet.chinatmsproviders'
  import {getHomeMenu} from '@/api/system';
  import {Toast} from 'vant';

  import {getElTypes, getMapPoints, getLines, getLineById, getMapInfo} from '../api/map';

  import {ConnectionPointTwo, SettingTwo} from '@icon-park/vue';

  import SoundWave from '@/components/SoundWave.vue';

  // import {GetGeoconvAsync} from '@/api/third-platform';

  import Notice from '@/components/Notice.vue';
  import HomeBasicInfo from '@/components/HomeBasicInfo.vue';

  import gcoord from 'gcoord';

  @Component({
    components:
      {
        Weather,
        PointContent,
        ConnectionPointTwo,
        SettingTwo,
        SoundWave,
        Notice,
        HomeBasicInfo
      }
  })
  export default class Home extends Vue {

    get percent() {
      return Math.min(1, this.currentTime / this.duration);
    }

    get color() {
      let color = this.$store.getters.background;
      if (!color) {
        color = '#1eb57a';
      }
      document.documentElement.style.setProperty('--color', color);
      return color;
    }

    get isNavTop() {
      let isNavTop = this.$store.getters.isShowNav;
      return isNavTop;
    }

    get homeMapColor() {
      let homeMapColor = this.$store.getters.homeMapColor;
      return homeMapColor;
    }

    get homeMapUrl() {
      let homeMapUrl = this.$store.getters.homeMapUrl;
      return homeMapUrl;
    }

    private typeItems = new Array<any>();
    private wshow = false;
    private cshow = false;
    private bshow = true;
    private notcieTop = 0;
    private pointId: Guid | undefined;
    private contentTitle = '';
    private isNavigation = false;
    private mapUrl = '';
    private latitude = '';
    private longitude = '';

    private bounds: L.LatLngBounds | undefined;
    private map: L.Map | undefined;
    private markerLayers: L.Marker[] = [];
    private markerGroup: L.Layer | undefined;
    private polyline: L.Polyline | undefined;
    private polylineOption: L.PolylineDecorator | undefined;
    private tooltipOptions: L.TooltipOptions = {
      permanent: true,
      direction: 'top',
      offset: L.point([0, -20]),
      opacity: 0.8,
      className: 'custom_tooltip'
    };

    private iconOption: L.IconOptions = {
      popupAnchor: [0, -28],
      iconUrl: require('../assets/default.png'),
      className: 'custom_marker'
    };

    private locateMarker: L.Marker | undefined;

    private isShowSearch = false;
    private searchValue = '';
    private lineActions: any[] = [];
    private points: any[] = [];
    private isLineShow = false;
    private menuBottoms: any[] = [];
    private menuTops: any[] = [];
    private baseUrl = Vue.prototype.$appsettings.serverUrl + '/';
    private isPosition = false;
    private currentMarker: L.Marker | undefined;
    private currentItem = {};

    private currentTime = 0;
    private duration = 0;
    private timer = 0;
    private audio: HTMLAudioElement | undefined;
    private isPlaying = false;
    private isPause = false;

    private isClickLine = '#606163';
    private lineId = '';

    private defaultCenter: L.LatLng | undefined;
    private zoom = 1;

    public async mounted() {
      await this.getHomeMenuList();
      await this.initMap();
      await this.getExplanationType();
      await this.getLineActions();
      // this.getDirection();
      this.getLocation();
    }

    public destroyed() {
      if (this.map) {
        this.map.stopLocate();
      }
    }

    public async getExplanationType() {
      const result = await getElTypes();
      this.typeItems = result.items;

      this.typeItems.splice(0, 0, {id: 0, explain: '全部'})

      if (this.typeItems.length > 0) {
        setTimeout(async () => {
          const first: any = this.typeItems[0];
          if (first.id) {
            await this.handlerElClick(first.id);
          }
          else{
            await this.handlerElClick('0');
          }
        }, 300);
      }
    }

    public async handlerElClick(id: string) {
      let parentDom = document.getElementById('tabAll');
      if (parentDom) {
        if (parentDom.children.length > 1) {
          const nodes = (parentDom.children as HTMLCollection);
          for (let item of nodes) {
            item.className = 'tab-item';
          }
        }
        let dom = document.getElementById('tab' + id);
        if (dom) {
          dom.className = 'tab-item active';
        }
      }
      const currentZoom = this.map?.getZoom();
      if (this.defaultCenter && currentZoom && currentZoom > this.zoom) {
        this.map?.setZoom(this.zoom);
        this.map?.setView(this.defaultCenter);
      }
      if (id && id!=='0'){
        await this.getPoints('', id);
      }
      else{
        await this.getPoints('', '');
      }
      this.getMarkers();
    }

    public async getPoints(name: string, id?: string) {
      const result = await getMapPoints(name, id);
      this.points = result.items;
    }

    public async handlerSearch() {
      await this.getPoints(this.searchValue);
      this.getMarkers();
    }

    public async getLineActions() {
      this.lineActions = [];
      const result = await getLines('');
      for (let item of result.items) {
        let action = {
          text: item.name,
          id: item.id,
          className: 'fontSize',
          icon: 'circle'
        };
        this.lineActions.push(action);
      }
    }

    public async handlerOnSelect(action: any) {
      for (let item of this.lineActions) {
        item.icon = 'circle';
      }
      this.isLineShow = false;
      if (this.map && this.polyline && this.polylineOption) {
        this.map.removeLayer(this.polyline);
        this.map.removeLayer(this.polylineOption);
      }

      if (this.lineId !== action.id) {
        action.icon = 'passed';
        this.isClickLine = this.color;
        this.lineId = action.id;
        const result = await getLineById(action.id);
        if (result.points) {
          this.bindPolyline(result);
        }
      } else {
        this.isClickLine = '#606163';
        this.lineId = '';
      }

    }

    private getIsNotice(v: boolean) {
      this.notcieTop = 0;
      if (v) {
        this.notcieTop = 25;
      }
    }

    private async getHomeMenuList() {
      const result = await getHomeMenu();
      if (result.totalCount > 0) {
        this.menuBottoms = result.items.filter((value: any) => {
          return value.position === 20;
        });

        this.menuTops = result.items.filter((value: any) => {
          return value.position === 10;
        });
      }
    }

    private async initMap() {
      const result = await getMapInfo();
      this.isPosition = result.isPositioning;
      this.defaultCenter = L.latLng([result.centerLat, result.centerLng]);
      this.map = L.map('map', {
        center: this.defaultCenter,
        zoomControl: false,
        attributionControl: false,
        zoom: 1,
        // crs: L.CRS.Simple
      });

      // 加载网络图片
      let imgUrl = this.baseUrl + result.mapUrl;

      if (result.mapUrl) {
        if (result.isHasLatlng) {
          this.bounds = new L.LatLngBounds([[result.latNortheast, result.lngNortheast], [result.latSouthwest, result.lngSouthwest]]);
          L.imageOverlay(imgUrl, this.bounds).addTo(this.map);
          this.map.setMaxBounds(this.bounds);
          this.zoom = this.map.getBoundsZoom(this.bounds, true);
          let maxZoom = this.zoom;
          if (result.maxLevel > 0) {
            maxZoom = this.zoom + result.maxLevel;
          }
          setTimeout(() => {
            if (this.map) {
              this.map.setZoom(this.zoom);
              this.map.setMinZoom(this.zoom);
              this.map.setMaxZoom(maxZoom);
            }
          }, 200);
        } else {
          let img = new Image();
          img.src = imgUrl;
          img.onload = () => {
            if (this.map) {
              this.map.setMinZoom(1);
              this.map.setMaxZoom(result.maxLevel - 1);
              let southWest = this.map.unproject([0, img.height], result.maxLevel - 1);
              let northEast = this.map.unproject([img.width, 0], result.maxLevel - 1);
              let bounds = new L.LatLngBounds(southWest, northEast);
              L.imageOverlay(imgUrl, bounds).addTo(this.map);
              this.map.setMaxBounds(bounds);

              // 窗口变化时重置
              // window.addEventListener('resize', () => {
              //   this.map.invalidateSize();
              //   this.map.fitBounds(bounds);
              // });
            }
          };
        }
      } else {
        // 加载天地图
        // const tdtvec = L.tileLayer('http://t{s}.tianditu.gov.cn/vec_c/wmts?' +
        //   'SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=c&FORMAT=tiles' +
        //   '&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=99af0897d6fd3c01edd5831b02ee9042', {
        //   subdomains: ['0', '1', '2', '3', '4', '5', '6', '7']
        // })
        //
        // const tdtcva = L.tileLayer('http://t{s}.tianditu.gov.cn/cva_c/wmts?' +
        //   'SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=c&FORMAT=tiles' +
        //   '&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=99af0897d6fd3c01edd5831b02ee9042', {
        //   subdomains: ['0', '1', '2', '3', '4', '5', '6', '7']
        // })

        const normalm = (L.tileLayer as any).chinaProvider('TianDiTu.Normal.Map', {
            maxZoom: 18,
            minZoom: 1,
            key: '99af0897d6fd3c01edd5831b02ee9042'
          }),
          normala = (L.tileLayer as any).chinaProvider('TianDiTu.Normal.Annotion', {
            maxZoom: 18,
            minZoom: 1,
            key: '99af0897d6fd3c01edd5831b02ee9042'
          })

        this.map.addLayer(normalm)
        this.map.addLayer(normala)

        // 设置缩放级别
        this.map.setZoom(14)
        this.zoom = 14
      }

      this.map.on('click', () => {
        this.isShowSearch = false;
        this.searchValue = '';

        this.isLineShow = false;
      });
    }

    private getMarkers() {
      this.markerLayers = [];
      this.markerGroup?.remove();
      for (let item of this.points) {
        // 判断是否有自定义图标
        let custom_icon = L.icon(this.iconOption);
        if (item.iconUrl) {
          const host = location.host
          custom_icon.options.iconUrl = `http://${host}/${item.iconUrl}`;

          if (item.isInRoom) {
            custom_icon.options.className = 'custom_marker_room';
          }
        }

        if (item.latitude && item.longitude) {
          let marker = L.marker([item.latitude, item.longitude], {
            icon: custom_icon
          });

          if (!item.isInRoom && !item.isHideTip) {
            marker.bindTooltip(item.name, this.tooltipOptions).openTooltip();
          }
          marker.on('click', () => {
            this.handlerContentClick(item, marker);
          });

          this.markerLayers.push(marker);
        }
      }

      this.markerGroup = L.layerGroup(this.markerLayers);
      this.map?.addLayer(this.markerGroup);
    }

    private handlerCdClick() {
      this.wshow = true;
    }

    private close(v: boolean) {
      this.wshow = v;
      this.cshow = v;
      this.bshow = v;
    }

    private handleClickYb() {
      if (this.currentItem && this.currentMarker) {
        this.handlerContentClick(this.currentItem, this.currentMarker);
      }
    }

    private handlerContentClick(item: any, marker: any) {
      if (item.isInRoom) {
        this.$router.push({
          path: '/floor/index',
          query: {
            roomId: item.id
          }
        });
      } else {
        this.cshow = true;
        this.contentTitle = item.name;
        this.isNavigation = item.isNavigation;
        this.mapUrl = item.mapUrl;
        this.latitude = item.latitude;
        this.longitude = item.longitude;

        if (this.pointId !== item.id) {
          this.currentItem = item;
          this.pointId = item.id;
          if (this.timer > 0) {
            clearInterval(this.timer);
            this.isPlaying = false;
            this.isPause = true;
            this.audio?.pause();
            this.currentTime = 0;
            this.duration = 0;
            this.handlerRemoveClass(this.currentMarker);
          }
          this.currentMarker = marker;
        }
      }

      // 点击点位时设置为中心点
      if (this.map && item.latitude && item.longitude) {
        this.map.setView([item.latitude, item.longitude]);
      }
    }

    private handlerAddClass(marker: any) {
      const has = L.DomUtil.hasClass(marker._icon, 'blinking');
      if (!has) {
        L.DomUtil.addClass(marker._icon, 'blinking');
      }
    }

    private handlerRemoveClass(marker: any) {
      if (marker) {
        const has = L.DomUtil.hasClass(marker._icon, 'blinking');
        if (has) {
          L.DomUtil.removeClass(marker._icon, 'blinking');
        }
      }
    }

    private handlerSearchClick() {
      this.isShowSearch = true;
    }

    private handlerClearSearch() {
      this.searchValue = '';
    }

    private handlerPositionClick() {
      this.getLocation();
    }

    private getContainer() {
      return document.getElementById('routes_menu');
    }

    private bindPolyline(line: any) {
      let latlngs = [];
      for (let obj of line.points) {
        let latlng = [obj.latitude, obj.longitude];
        latlngs.push(latlng);
      }
      if (this.map) {
        // 点击获取第一个坐标点为中心点
        if (latlngs.length > 0) {
          this.map.setView([latlngs[0][0], latlngs[0][1]]);
        }

        this.polyline = L.polyline(latlngs, {weight: 5}).addTo(this.map);
        this.polylineOption = L.polylineDecorator(this.polyline, {
          patterns: [
            {
              offset: 10, repeat: 50, symbol: L.Symbol.arrowHead({
                pixelSize: 4,  // 箭头大小
                headAngle: 70,  // 角度
                polygon: false,
                pathOptions: {stroke: true, weight: 2, color: '#fff'}
              }),
            },
            {
              offset: 0, endOffset: 0, repeat: '100%', symbol: L.Symbol.marker({
                rotate: false, markerOptions: {
                  icon: L.icon({
                    iconUrl: require('@/assets/start.png'),
                    iconSize: [20, 34],
                    iconAnchor: [10, 16]
                  })
                }
              })
            },
            {
              offset: '100%', endOffset: 0, repeat: '100%', symbol: L.Symbol.marker({
                rotate: false, markerOptions: {
                  icon: L.icon({
                    iconUrl: require('@/assets/end.png'),
                    iconSize: [20, 34],
                    iconAnchor: [10, 20]
                  })
                }
              })
            },
          ]
        }).addTo(this.map);

        this.polyline.on('click', () => {
        });
      }
    }

    private handleClickItem(item: any) {
      if (item.link) {
        window.location.href = item.link;
      }
    }

    private getLocation() {
      if (this.isPosition) {
        if (this.map) {
          this.map.locate({
            watch: true,
            timeout: 30000,
            enableHighAccuracy: true,
            maximumAge: 600000
          });

          this.map.on('locationerror', () => {
            this.map?.stopLocate();
            Toast({
              message: '获取地理位置失败',
              position: 'bottom',
            });
          });

          const that = this;
          this.map.on('locationfound', async function(e: any) {
            if (that.bounds) {
              // 31.901123046875, 118.90364837646484
              // e.latlng.lat, e.latlng.lng
              const point = L.latLng([e.latlng.lat, e.latlng.lng]);
              const flag = that.bounds.contains(point);
              if (!flag) {
                that.map?.stopLocate();
                Toast({
                  message: `当前位置未在该地图范围内`,
                  position: 'bottom',
                });
                return false;
              }

              if (that.map) {
                // 清除上一个坐标点
                if (that.locateMarker) {
                  that.map.removeLayer(that.locateMarker);
                }

                let icon = L.icon({
                  iconUrl: require('../assets/locate_arrow.png'),
                  iconSize: [14, 21]
                });

                that.locateMarker = L.marker(point, {
                  rotationOrigin: 'center center',
                  zIndexOffset: -1,
                  icon
                }).addTo(that.map);

                that.getDirection(that.locateMarker);
                that.map.setView(point);
              }
            }
          });
        }
      }
    }

    private getDirection(marker: L.Marker) {
      let ua = navigator.userAgent.toLowerCase();

      if (/android/.test(ua)) {
        window.addEventListener('deviceorientationabsolute', function(e) {
          if (e.alpha) {
            let dushu = 360 - e.alpha;
            const rotate = Math.round(dushu);
            marker.setRotationAngle(rotate);
            // alert(e.alpha);
          }
        }, false);
      } else {
        window.addEventListener('deviceorientation', function(e) {
          // @ts-ignore
          // marker.setRotationAngle(e.webkitCompassHeading);
        }, false);
      }
    }

    private playAudio(audioUrl: string, chineseAudioFile: string) {
      if ((audioUrl || chineseAudioFile)) {
        this.audio = new Audio();
        if (chineseAudioFile) {
          this.audio.src = chineseAudioFile;
        } else {
          this.audio.src = audioUrl;
        }
      }
    }

    private handlerPlay() {
      if (this.audio) {
        const play = this.audio.play();
        this.isPlaying = true;
        this.isPause = false;
        // 点闪烁
        if (this.currentMarker) {
          this.handlerAddClass(this.currentMarker);
        }
        play.then(() => {
          if (this.audio) {
            this.duration = this.audio.duration;
          }
          this.timer = setInterval(() => {
            if (this.audio) {
              this.currentTime = this.audio.currentTime;
              if (this.currentTime === this.duration) {
                clearInterval(this.timer);
                this.isPlaying = false;
                if (this.currentMarker) {
                  this.handlerRemoveClass(this.currentMarker);
                }
              }
            }
          }, 1000);
        });
      }
    }

    private handlerPause() {
      if (this.audio && this.isPlaying) {
        this.audio.pause();
        this.handlerRemoveClass(this.currentMarker);
        this.isPause = true;
        this.isPlaying = false;
        if (this.timer > 0) {
          clearInterval(this.timer);
        }
      }
    }
  }
